<template>
  <div>
    <div
      v-for="(desc, char) in sevenChar"
      :key="char"
      class="flexCol d-flex flex-row"
    >
      <span :class="codeClass">{{ codeWith7(code, char) }}</span>
      <span class="d-flex flex-row flex-wrap">
        <span v-html="simplifyLaterality(label)"></span>
        <span>
          &nbsp;-&nbsp;
          <span
            class="sevenCodeClass"
            :style="'background-color:' + colorFor7[char]"
            >{{ desc }}</span
          ></span
        >
      </span>
    </div>
  </div>
</template>

<script>
import FormatIcdMixin from "@/assets/js/icd/FormatIcdMixin";

export default {
  name: "CodeWith7",
  mixins: [FormatIcdMixin],
  props: {
    sevenChar: null,
    label: null,
    code: null,
    codeClass: {
      Type: String,
      default: "font-weight-medium mr-2",
    },
  },
  data: function () {
    return {
      colors7: [
        "#c9e3d5",
        "#CFEAEA",
        "#ecfac7",
        "#e7dadd",
        "#dde9eb",
        "#facba9",
        "#dfdbd3",
        "#f1fdc1",
      ],
    };
  },
  methods: {
    codeWith7(code, char) {
      let rtn = "";
      for (var i = 0; i < 8; i++) {
        if (code.charAt(i)) {
          rtn += code.charAt(i);
        } else if (i == 7) {
          rtn += char;
        } else {
          rtn += "X";
        }
      }
      return rtn;
    },
  },
  computed: {
    colorFor7: function () {
      let rtn = {};
      let chars = Object.keys(this.sevenChar);
      let i = 0;
      for (const char of chars) {
        rtn[char] = this.colors7[i];
        i++;
      }
      return rtn;
    },
  },
};
</script>

<style scoped></style>
